import React, { FC, useEffect } from 'react';
import { Text } from '@mofid-securities/uikit';
import { IInputProps } from '@/components/atomic/Input';
import { FormField } from '@/components/HookForm';
import Input from '@/components/Input';
import { OtpTimer } from '@/components/OtpTimer';

interface IOtpInputField extends IInputProps {
  handleOtpSend: () => void;
  isLoading: boolean;
  fieldName: string;
  shouldSendOtpOnMount?: boolean;
  isFullWidth?: boolean;
}

export const OtpInputField: FC<IOtpInputField> = ({
  handleOtpSend,
  isLoading,
  fieldName,
  isRequired,
  shouldSendOtpOnMount = false,
  isFullWidth = false,
  ...rest
}) => {
  useEffect(() => {
    if (shouldSendOtpOnMount) handleOtpSend();
  }, []);

  return (
    <FormField
      className="mb-20"
      isFullWidth={isFullWidth}
      isRequired={isRequired}
      name={fieldName}
      render={({ field }) => (
        <Input
          className="text-center placeholder:!text-center"
          classNames={{
            container: '!h-12',
          }}
          endAdornment={
            <OtpTimer
              handleRequest={handleOtpSend}
              isRequestLoading={isLoading}
            />
          }
          helperText={
            <Text color="yellow-60" size="xs">
              مدت اعتبار کد ارسال شده ۲ دقیقه است
            </Text>
          }
          maxLength={6}
          placeholder="کد تایید را وارد کنید"
          isNumeric
          {...rest}
          {...field}
        />
      )}
    />
  );
};
